import { useEffect, useState } from "react";
import { Button, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, FormLabel, InputLabel, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationSchema } from "../services/SchemaValidation"
import { useMutation } from "react-query";
import { useQuery } from "react-query"
import { getPropertyTypes, saveProperty } from "../../../services/api/Property"
import { ValidateErrorMessage } from "../../../components/ValidateErrorMessage";
import DialogC from '../../../components/Dialog/index'

export default function Add({ open, setOpen, reportAction }) {
  const [isLoading, setIsLoading] = useState(false);
  const [dataAddData, setDataAddData] = useState({})
  const [valueRGAdd, setValueRGAdd] = useState([]);
  let { reset, handleSubmit, register, formState: { errors } } = useForm({ 
    resolver: yupResolver(ValidationSchema) 
  })
  const { isLoading: ptLoadingAdd, isFetching: ptFetchingAdd, refetch: ptRefetchAdd, error: ptErrorAdd, data: propertyTypesAdd } = useQuery(
    'propertyTypesAddList', 
    getPropertyTypes, 
    { refetchOnWindowFocus: false, enabled: false } 
  )

  useEffect(() => { if(open) { ptRefetchAdd() } }, [open])

  const mutation = useMutation(saveProperty, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { reportAction('add', false, { message: 'Error al agregar los datos'}, false)
      } else { reportAction('add', false, { }, true) }
    }
  })

  const onSubmit = (params) => { 
    params.property_type = params.property_type.filter(pt => pt !== false)
    console.log("Params:", params)
    setIsLoading(true)
    mutation.mutate(params)
  }

  useEffect(() => {
    if(propertyTypesAdd !== undefined && propertyTypesAdd != null) {
      let tempObject = []
      propertyTypesAdd.data.forEach(element => {
        element.selected = false
        tempObject.push(element)
      });      
      setValueRGAdd(tempObject)
    }
  }, [propertyTypesAdd])

  const handleChangeRG = (event) => {
    let findIndex = valueRGAdd.findIndex(element => element._id === event.target.value)
    let newArr = [...valueRGAdd]
    newArr[findIndex].selected ? newArr[findIndex].selected = false : newArr[findIndex].selected = true
    setValueRGAdd(newArr)
  }

  const handleOnChangeData = (event) => { 
    setDataAddData({...dataAddData, [event.target.name]: event.target.value}) 
  }

  const handleClose = () => { reset(); setDataAddData({}); setValueRGAdd([]); setOpen(false) }

  const Actions = () => (<>
    { !isLoading ? <>
      <Button onClick={handleClose}>Cancel</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(onSubmit)}>Agregar</Button>
      </> : <CircularProgress /> }
  </>)

  if(ptLoadingAdd || ptFetchingAdd) return <div>Cargando...</div>
  if(ptErrorAdd) return <div> Ha ocurrido un error </div>

  return (<>
    <DialogC open={open} title={`Agregar`} actions={<Actions />}>
      <InputLabel htmlFor='property_name' required style={{ fontSize: 14 }}>Nombre</InputLabel>
      <TextField id='property_name' fullWidth margin="dense" type="text" name='property_name'
        value={dataAddData.property_name || ""}
        {...register(`property_name`)} 
        error={errors.property_name ? true: false}
        onChange={handleOnChangeData} />
      <ValidateErrorMessage message={errors.property_name?.message} /><br />
      <InputLabel htmlFor='tradename' required style={{ fontSize: 14 }}>Nombre comercial</InputLabel>
      <TextField id='tradename' fullWidth margin="dense" type="text" name='tradename'
        value={dataAddData.tradename || ""}
        {...register(`tradename`)} 
        error={errors.tradename ? true: false}
        onChange={handleOnChangeData} />
      <ValidateErrorMessage message={errors.tradename?.message} /><br />
      <FormControl>
        <FormLabel style={{ fontSize: 14 }}>Tipo de Propiedad</FormLabel>
        <FormGroup aria-label="position" onChange={handleChangeRG}>
          { valueRGAdd.map((type, index) => (
            <FormControlLabel key={`${index}-${type._id}`} control={
              <Checkbox value={type._id} checked={type.selected} name="property_type" {...register(`property_type.${index}`)} />
            } label={type.name} labelPlacement="end" />
          ))}
        </FormGroup>
      </FormControl>
      <ValidateErrorMessage message={errors.property_type?.message} /><br />
      <InputLabel htmlFor='slug' required style={{ fontSize: 14 }}>Slug</InputLabel>
      <TextField id='slug' fullWidth margin="dense" type="text" name='slug'
        value={dataAddData.slug || ""}
        {...register(`slug`)} 
        error={errors.slug ? true: false}
        onChange={handleOnChangeData} />
      <ValidateErrorMessage message={errors.slug?.message} /><br />
      <InputLabel htmlFor='total_rent_square_meters' required style={{ fontSize: 14 }}>Total de metros cuadrados rentables</InputLabel>
      <TextField id='total_rent_square_meters' fullWidth margin="dense" type="number" name='total_rent_square_meters' 
        value={dataAddData.total_rent_square_meters || ""}
        {...register(`total_rent_square_meters`)} 
        error={errors.total_rent_square_meters ? true: false}
        onChange={handleOnChangeData} />
      <ValidateErrorMessage message={errors.total_rent_square_meters?.message} /><br />
      <InputLabel htmlFor='towers_buildings_number' required style={{ fontSize: 14 }}>Total de torres / edificios</InputLabel>
      <TextField id='towers_buildings_number' fullWidth margin="dense" type="number" name='towers_buildings_number' 
        value={dataAddData.towers_buildings_number || ""}
        {...register(`towers_buildings_number`)} 
        error={errors.towers_buildings_number ? true: false}
        onChange={handleOnChangeData} />
      <ValidateErrorMessage message={errors.towers_buildings_number?.message} /><br />
      <InputLabel htmlFor='parking_spaces' required style={{ fontSize: 14 }}>Total de espacios de estacionamiento</InputLabel>
      <TextField id='parking_spaces' fullWidth margin="dense" type="number" name='parking_spaces' 
        value={dataAddData.parking_spaces || ""}
        {...register(`parking_spaces`)} 
        error={errors.parking_spaces ? true: false}
        onChange={handleOnChangeData} />
      <ValidateErrorMessage message={errors.parking_spaces?.message} /><br />
    </DialogC>
  </>)
}